/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/DesignSystem/PatientImageCard/Preview"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientImageUrlValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'url',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(patientImageUrlValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}